import { useFetchMembershipStatus } from '@/api/hooks/useFetchMembershipStatus'
import { useAuthStore } from '@/store'
import { Redirect, usePathname } from 'expo-router'

/**
 * Signed in, and on an active membership, or else redirected to where that gets fixed.
 *
 * `requireActiveMembership` is off for the one screen an inactive member must still reach:
 * support, which is where the inactive-membership page sends them.
 */
const ProtectedPage = ({
	children,
	requireActiveMembership = true,
}: { children: React.ReactNode; requireActiveMembership?: boolean }) => {
	const { isAuthenticated } = useAuthStore()
	const pathname = usePathname()
	const { hasActiveMembership, isFetchingStatus } = useFetchMembershipStatus()

	if (!isAuthenticated) {
		return (
			<Redirect
				href={{
					pathname: '/login',
					params: {
						redirectTo: pathname,
					},
				}}
			/>
		)
	}

	if (requireActiveMembership && !isFetchingStatus && !hasActiveMembership) {
		return <Redirect href="/inactive-membership" />
	}

	return children
}

export default ProtectedPage
